@if (layout.isCompact()) {
  <!-- Mini bar -->
  <div class="mini">
    <div class="mini__open" role="button" tabindex="0" (click)="openNowPlaying()" (keydown.enter)="openNowPlaying()">
      <span class="art art--sm">
        @if (imageUrl() && !imageFailed()) {
          <img [src]="imageUrl()" alt="" (error)="onImageError()" />
        } @else {
          <mat-icon fontSet="material-icons-outlined">album</mat-icon>
        }
      </span>
      <span class="mini__meta">
        <span class="mini__title">{{ isError() ? 'Playback failed' : title() }}</span>
        <span class="mini__sub">
          @if (isError()) { Check your connection }
          @else if (!hasTrack()) { Tap play to start something }
          @else { {{ subtitle() || elapsed() }} }
        </span>
      </span>
    </div>
    <button
      type="button"
      class="btn-play btn-play--sm"
      (click)="playPause()"
      [attr.aria-label]="isPlaying() ? 'Pause' : 'Play'"
    >
      @if (isBusy()) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        <mat-icon>{{ isPlaying() ? 'pause' : 'play_arrow' }}</mat-icon>
      }
    </button>
  </div>
} @else {
  <!-- Desktop transport bar -->
  <div class="bar">
    <div class="bar__now" role="button" tabindex="0" (click)="openNowPlaying()" (keydown.enter)="openNowPlaying()">
      <span class="art">
        @if (imageUrl() && !imageFailed()) {
          <img [src]="imageUrl()" alt="" (error)="onImageError()" />
        } @else {
          <mat-icon fontSet="material-icons-outlined">album</mat-icon>
        }
      </span>
      <span class="bar__meta" aria-live="polite">
        <span class="bar__title">{{ isError() ? 'Playback failed' : MiscUtils.truncateChar(title(), 46) }}</span>
        <span class="bar__sub">
          @if (isError()) { Check your connection and try again }
          @else if (!hasTrack()) { Pick a station, or hit play for a random one }
          @else { {{ MiscUtils.truncateChar(subtitle() || 'Internet radio', 54) }} }
        </span>
        @if (hasTrack()) {
          <span class="bar__time">{{ elapsed() }}</span>
        }
      </span>
    </div>

    <div class="bar__transport">
      <div class="bar__buttons">
        <!-- Previous/next don't make sense for internet radio playback. -->
        <button
          type="button"
          class="btn-play"
          (click)="playPause()"
          [matTooltip]="isPlaying() ? 'Pause' : 'Play'"
          [attr.aria-label]="isPlaying() ? 'Pause' : 'Play'"
        >
          @if (isBusy()) {
            <mat-spinner diameter="22"></mat-spinner>
          } @else {
            <mat-icon>{{ isPlaying() ? 'pause' : 'play_arrow' }}</mat-icon>
          }
        </button>
      </div>
    </div>

    <div class="bar__extras">
      <div class="bar__wave" [class.is-live]="isPlaying() && !equalizerBypassed()" aria-hidden="true">
        <audiowaveform-component></audiowaveform-component>
      </div>
      <button
        type="button"
        class="hx-icon-btn"
        (click)="muteUnmute()"
        [attr.aria-label]="isMuted() ? 'Unmute' : 'Mute'"
      >
        <mat-icon>{{ isMuted() ? 'volume_off' : 'volume_up' }}</mat-icon>
      </button>
      <mat-slider class="bar__volume" min="0" max="1" step="0.025">
        <input
          matSliderThumb
          [ngModel]="volume()"
          (ngModelChange)="onVolume($event)"
          aria-label="Volume"
        />
      </mat-slider>
    </div>
  </div>
}
